// Shared "this month vs last month" Sales/Purchase computation, used by every dashboard that
// shows the Sales/Purchase donuts (Top Level, Finance). Sources from Reports/GetMonthSalesPurchaseSummary:
// pre-tax BasicValue from ClientInvoice (Sales) / VendorInvoice (Purchase), Status != 'Rejected',
// by InvoiceDate, CC-scoped. (Previously summed transaction-log rows, whose Client Invoice
// value included tax.)
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    fetchMonthSalesPurchaseSummary,
    selectSalesPurchaseSummary,
} from '../../slices/dashboardSlice/financialOverviewSlice';

export const useSalesPurchaseMetrics = (roleId, userId) => {
    const dispatch = useDispatch();

    const summary = useSelector(selectSalesPurchaseSummary);

    useEffect(() => {
        // roleId/userId drive backend CC-scoping: for roles with ApplicableForCC='Yes',
        // totals are restricted to this user's assigned cost centers.
        dispatch(fetchMonthSalesPurchaseSummary({ roleId, userId }));
    }, [dispatch, roleId, userId]);

    const currentMonthSales = parseFloat(summary?.CurrentMonthSales || 0);
    const currentMonthPurchase = parseFloat(summary?.CurrentMonthPurchase || 0);
    const previousMonthSales = parseFloat(summary?.PreviousMonthSales || 0);
    const previousMonthPurchase = parseFloat(summary?.PreviousMonthPurchase || 0);

    const salesGrowth = previousMonthSales > 0
        ? ((currentMonthSales - previousMonthSales) / previousMonthSales * 100).toFixed(1)
        : 0;

    const purchaseGrowth = previousMonthPurchase > 0
        ? ((currentMonthPurchase - previousMonthPurchase) / previousMonthPurchase * 100).toFixed(1)
        : 0;

    return {
        currentMonthSales,
        currentMonthPurchase,
        previousMonthSales,
        previousMonthPurchase,
        salesGrowth: parseFloat(salesGrowth),
        purchaseGrowth: parseFloat(purchaseGrowth),
    };
};
